import {Component, EventEmitter, Input, Output} from '@angular/core';
import { FaqNodeDto } from '../../../domain/faq/faqNodeDto';
import { GhostComponent } from '../../../utils/ghostComponent';

@Component({
    selector: 'faq-list',
    templateUrl: './faqList.component.html',
    styleUrls: ['./faqList.component.scss']
})
export class FaqListComponent extends GhostComponent {

    @Input() faqNodes: FaqNodeDto[];
    @Output() faqNodeSelected: EventEmitter<FaqNodeDto> = new EventEmitter<FaqNodeDto>();

    constructor() {
        super();
    }

    trackById(index: number, faqNode: FaqNodeDto): string {
        return faqNode?.id;
    }

    selectFaqNode(faqNode: FaqNodeDto) {
        this.faqNodeSelected.emit(faqNode);
    }

    generateGhost(): void {
    }
}
